import React from "react";

export default function Icon() {
  return (
    <>
      <div className="icons-container">
        <div className="icons">
          <img src={"./images/icon1.png"} />
          <h3>recycle</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Unde
            itaque consequatur, quis corporis ad sequi nihil nam rerum! Odio,
            at!
          </p>
          <a href="#" className="btn">
            learn more
          </a>
        </div>
        <div className="icons">
          <img src={"./images/icon2.png"} alt="" />
          <h3>solar panel</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Unde
            itaque consequatur, quis corporis ad sequi nihil nam rerum! Odio,
            at!
          </p>
          <a href="#" className="btn">
            learn more
          </a>
        </div>
        <div className="icons">
          <img src={"./images/icon3.png"} />
          <h3>save water</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Unde
            itaque consequatur, quis corporis ad sequi nihil nam rerum! Odio,
            at!
          </p>
          <a href="#" className="btn">
            learn more
          </a>
        </div>
        <div className="icons">
          <img src={"./images/icon4.png"} />
          <h3>windmill</h3>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Unde
            itaque consequatur, quis corporis ad sequi nihil nam rerum! Odio,
            at!
          </p>
          <a href="#" className="btn">
            learn more
          </a>
        </div>
      </div>
    </>
  );
}
